import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { sendNotification } from "../api/plan";
import { SHOW_SNACKBAR } from "../utils/types";
import { generateTokenByApiKey } from "../api/login";
import { getEmailBody } from "../utils/helper";

const Contact = () => {
  const [notification, setNotification] = useState({});
  let dispatch = useDispatch();

  const onSendEmail = (e) => {
    e.preventDefault();
    const { name, email, phone, subject, message } = notification;
    const emailBody = getEmailBody(name, email, phone, message);

    const request = {
      notificationType: "EMAIL",
      from: process.env.REACT_APP_SENDER_EMAIL,
      subject: subject || "Contact Form Submission",
      toUsers: {
        [process.env.REACT_APP_TO_EMAIL]: {
          email: process.env.REACT_APP_TO_EMAIL
        }
      },
      body: emailBody
    };
    dispatch(
      generateTokenByApiKey(
        {},
        "zealthix",
        {
          "x-tenant-id": process.env.REACT_APP_TENANT_ID,
          "X-Api-Key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
        (t) => {
          if (t.access_token) {
            dispatch(sendNotification(request, t.access_token, a => {
              e.target.reset();
              setNotification({});
              dispatch({
                type: SHOW_SNACKBAR,
                payload: {
                  type: "error",
                  message: "Email sent successfully",
                  open: true,
                },
              });
            }))
          }
        }
      )
    );
  }

  return (
    <>
      {/* <form onSubmit={onSendEmail} className="row">
        <div className="col-lg-6">
          <div className="input-area">
            <input type="text" placeholder="Full Name*" value={notification?.name}
              required onChange={(e) => setNotification({ ...notification, name: e.target.value })} />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="input-area">
            <input type="tel" placeholder="Phone Number*" value={notification?.phone}
              required onChange={(e) => setNotification({ ...notification, phone: e.target.value })} />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="input-area">
            <input type="email" placeholder="Email Address*" value={notification?.email}
              required onChange={(e) => setNotification({ ...notification, email: e.target.value })} />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="input-area">
            <input type="text" placeholder="Subject*" value={notification?.subject}
              required onChange={(e) => setNotification({ ...notification, subject: e.target.value })} />
          </div>
        </div>
        <div className="col-lg-12">
          <div className="input-area">
            <textarea className="resize-none" placeholder="Your Message" value={notification?.message || ""}
              required onChange={(e) => setNotification({ ...notification, message: e.target.value })} />
          </div>
        </div>
        <div className="col-lg-12">
          <div className="space10" />
          <div className="input-area">
            <button type="submit" className="vl-btn6 flex items-center gap-[8px] justify-center">
              <span>Submit Now</span>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={22}
                  height={22}
                  viewBox="0 0 22 22"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z"
                    fill="white"
                  />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </form> */}



      <div className="min-h-screen mt-[86px] bg-slate-50 py-10 px-4 flex flex-col items-center">
        <div className="max-w-6xl w-full flex flex-col md:flex-row gap-8">
          <div className="w-full md:w-1/2  p-8 rounded-md ">
            <h1 className="text-3xl font-bold text-slate-800 mb-3">Contact Us</h1>
            <p className="text-slate-600 mb-6">
              We'd love to hear from you! Whether you have questions about our plans,
              need assistance, or want more information about our services, our team
              is here to help.
            </p>
            {/* <div className="flex items-start mb-4 text-slate-700">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth={0}
                viewBox="0 0 384 512"
                className="text-violet-600 mt-1 mr-2"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
              </svg>
              <p>
                <span className="text-fuchsia-600 font-bold block">
                  Basement, 5B-16, Tilak Nagar New Delhi 110018
                </span>
              </p>
            </div> */}
            <div className="flex items-center mb-3 text-slate-700">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth={0}
                viewBox="0 0 512 512"
                className="text-violet-600 mr-2"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M424 80H88a56.06 56.06 0 0 0-56 56v240a56.06 56.06 0 0 0 56 56h336a56.06 56.06 0 0 0 56-56V136a56.06 56.06 0 0 0-56-56zm-14.18 92.63-144 112a16 16 0 0 1-19.64 0l-144-112a16 16 0 1 1 19.64-25.26L256 251.73l134.18-104.36a16 16 0 0 1 19.64 25.26z" />
              </svg>
              <a
                href="mailto:support@magmaopd.in"
                className="text-fuchsia-600 hover:underline"
              >
                support@magmaopd.in
              </a>
            </div>
            <div className="flex items-center text-slate-700">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth={0}
                viewBox="0 0 512 512"
                className="text-violet-600 mr-2"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" />
              </svg>
              <a href="tel:9899761818" className="text-fuchsia-600 hover:underline">
                9899761818
              </a>
            </div>
          </div>
          <div className="w-full md:w-1/2  p-8 rounded-md ">
            <form noValidate="">
              <div className="mb-4">
                <label className="block text-sm font-medium text-slate-700 mb-1">
                  Your name
                </label>
                <input
                  type="text"
                  name="name"
                  className="w-full h-11 px-3 py-2 border border-gray-300 rounded-lg text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-violet-600 bg-white focus:border-transparent"
                  defaultValue=""
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-slate-700 mb-1">
                  Your email
                </label>
                <input
                  type="email"
                  name="email"
                  className="w-full h-11 px-3 py-2 border border-gray-300 rounded-lg text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-violet-600 bg-white focus:border-transparent"
                  defaultValue=""
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-slate-700 mb-1">
                  Mobile No.
                </label>
                <input
                  type="text"
                  name="mobileNo"
                  className="w-full h-11 px-3 py-2 border border-gray-300 rounded-lg text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-violet-600 bg-white focus:border-transparent"
                  defaultValue=""
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-slate-700 mb-1">
                  Choose Your Plan
                </label>
                <select
                  name="plan"
                  className="w-full h-11 px-3 py-2 border border-gray-300 rounded-lg text-sm text-slate-700 bg-white focus:outline-none focus:ring-2 focus:ring-violet-600 focus:border-transparent"
                >
                  <option value="">Select a Package</option>
                  <option value="Magma Premium Care">Magma Premium Care</option>
                  <option value="Magma Health Shield">Magma Health Shield</option>
                </select>
              </div>
              <button
                type="submit"
                className="w-full bg-violet-600 text-white font-bold py-2 rounded-md hover:bg-violet-700 transition"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
        <div className="w-full mt-10">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.6875277668655!2d77.08406657528936!3d28.63912577566109!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d052015491755%3A0xa59ac50c2af42186!2sBasement%2C%205B%2C%2016%2C%20Block%20F%2C%20Tilak%20Nagar%2C%20New%20Delhi%2C%20Delhi%2C%20110018!5e0!3m2!1sen!2sin!4v1750844856004!5m2!1sen!2sin"
            width="100%"
            height={450}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="border-0 w-full"
            title="Basement, 5B"
          />
        </div>
      </div>

    </>
  );
};

export default Contact;
